/**
 * FikoYT Shared Library
 * Tüm MFE'lerde ortak kullanılan servisler, modüller ve temalar
 */

// Environment
export { FikoYTEnvIstemci } from './lib/environment/environment';

// Servisler
export { FikoYTService } from './lib/service/fikoyt.service';
export { FikoYTArayuz } from './lib/service/fikoyt.arayuz.service';
export { KimlikService } from './lib/service/kimlik.service';
export { LanguageService } from './lib/service/language.service';
export { CihazKimlikService } from './lib/service/fikoyt.cihaz-kimlik.service';
export { SeriPortService } from './lib/service/fikoyt.seri-port.service';
export { SocketFikoYT } from './lib/service/fikoyt.socket.service';
export { FikoYTIstekService, IstekOlayTuru } from './lib/service/fikoyt.istek.service';

// Kök Bileşen
export { FikoYTKokBilesenComponent } from './lib/service/kok-bilesen/kok-bilesen.component';
export { BreakpointObserver } from './lib/service/kok-bilesen/breakpoints-observer';
export { Breakpoints } from './lib/service/kok-bilesen/breakpoints';

// Icons Provider
export { icons } from './lib/service/icons-provider';

// Temalar
// temalar.less ve ngZorroGlobal.less doğrudan import edilebilir
// FikoYT UI — taşınan ortak çekirdek (paylasim-sistemi & fiko-three-js hariç)
export * from './lib/service/fikoyt-ui/index';

// Uygulama route'ları (MFE remote'lar bunları host'ta yükler)
export { HMI_PANO_ROUTES } from './lib/app/uygulamalar/hmi-pano/hmi-pano.routes';

// Uye-olmayan sayfalari (giris/kayit/sifre-sifirla) — remote barrel uzerinden erisim icin
export * from './lib/app/guards/uye.guard';
export * from './lib/app/sayfalar/kullanici/uye-olmayan/giris-yap/giris-yap.component';
export * from './lib/app/sayfalar/kullanici/uye-olmayan/aramiza-katil/aramiza-katil.component';
export * from './lib/app/sayfalar/kullanici/uye-olmayan/sifre-sifirla/sifre-sifirla.component';
export * from './lib/service/fikoyt-ui/src/lib/fikoyt-kart/fikoyt-kart.component';
export * from './lib/service/fikoyt-ui/src/lib/fikoyt-dalga/fikoyt-dalga.component';
export * from './lib/service/fikoyt-ui/src/lib/fikoyt-yuvarlak-resim/fikoyt-yuvarlak-resim.component';
export { PAYLASIM_SISTEMI_ROUTES } from './lib/app/uygulamalar/paylasim-sistemi/paylasim-sistemi.routes';
// tr-TR locale verisi (MFE: '@angular/common/locales/tr' federation'da cozulemiyor)
export { default as localeTr } from './lib/app/locale-tr';
